import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  saldo_disponivel: string;
  total_ganho: string;
  numero_vendas: string;
}

// tipagem do que o hook retorna
type ICertificadoReponse = IResponseData;

async function getDashboard(): Promise<ICertificadoReponse> {
  const response = await backend.get<IResponseData>(`/dashboard`);
  return response.data;
}

export function useDashboard() {
  return useQuery(['dashboard'], () => getDashboard(), {
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
    // refetchOnWindowFocus: false,
  });
}
